import script from "./CreateEventDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEventDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateEventDialog.vue?vue&type=style&index=0&id=2f764936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f764936"]])

export default __exports__